import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { MdiReactIconComponentType } from 'mdi-react/';
import React, { FunctionComponent, SVGProps } from 'react';

interface IProps {
  icon?: MdiReactIconComponentType | FunctionComponent<SVGProps<SVGSVGElement>>;
  message: any;
  classes?: any;
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: '20px',
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  icon: {
    opacity: 0.7,
    flex: 1,
    fontSize: 50
  },
  svgIcon: {
    textAlign: 'center',
    '& svg': {
      height: 50,
      opacity: 0.7
    }
  },
  button: {
    marginTop: 20
  },
  text: {
    textTransform: 'none'
  }
}));

const IconMessage = (props: IProps) => {
  const { message, icon } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {icon && (<props.icon size={50} height={50} className={classes.icon} />)}
      <Typography
        align="center"
        variant='overline'
        color='textSecondary'
        className={classes.text}
      >
        {message}
      </Typography>
    </div>
  );
};

export default IconMessage;